import React from "react";
import DogIcon from "./DogIcon";

interface MapPlaceholderProps {
    captionText: React.ReactNode;
}

const MapPlaceholder: React.FC<MapPlaceholderProps> = (props) => {

    return (
        <div className="blj-store-locator-map-placeholder">
            <div className="blj-store-locator-map-placeholder__dog">
                <DogIcon/>
            </div>
            <span className="blj-store-locator-map-placeholder__caption">
                {props.captionText}
            </span>
        </div>
    );

}

export default MapPlaceholder;